import React from 'react'
import { connect } from 'react-redux'
import SearchBar from '@chegg-wt/core/components/SearchBar'
import { Tooltip } from '@chegg-ui/tooltip'
import { IconButton } from '@chegg-ui/button'
import { FoldersState } from '@chegg-wt/core/state/folders/types'
import { Input } from '@chegg-ui/input'
import { SearchIcon } from '@chegg-ui/theme'
import { CITATION_LIST_NAME_LOWER_PLURAL } from '@chegg-wt/core/constants/citations'
import { setFolderId } from '@chegg-wt/core/state/folders/actions'
import { searchProjects } from '@chegg-wt/core/state/projects/actions'
import * as Styled from './styled'
import { PROJECT_SEARCH_BAR_BUTTON } from './testIds'

interface Props {
  search: (searchValue: string) => void
  setFolderId: (id: FoldersState['id']) => void
}

export const ProjectSearchBar: React.FC<Props> = ({ search, setFolderId }) => {
  const handleSearch = (searchValue) => {
    search(searchValue)
    setFolderId(null)
  }

  return (
    <SearchBar search={handleSearch}>
      {({ searchValue, setSearchValue, onKeyDown, onSearch }) => (
        <Styled.SearchInputContainer>
          <Input
            data-test="search-input"
            placeholder={`Search ${CITATION_LIST_NAME_LOWER_PLURAL}`}
            value={searchValue}
            // chegg-ui/input's onChange takes value from e.target.value
            onChange={(value) => setSearchValue(value)}
            onKeyDown={onKeyDown}
            // required for chegg-ui input component
            inputId="search-input"
            labelText="search input"
            visuallyHideLabel
          />
          <Tooltip
            position="top"
            targetElement={
              <Styled.SearchGlassContainer>
                <IconButton
                  screenReaderOnlyText="Search citations"
                  onClick={() => {
                    onSearch(searchValue)
                  }}
                  data-test={PROJECT_SEARCH_BAR_BUTTON}
                  name="search"
                  size="medium"
                >
                  <SearchIcon />
                </IconButton>
              </Styled.SearchGlassContainer>
            }
          >
            <span aria-label="Search citations">Search</span>
          </Tooltip>
        </Styled.SearchInputContainer>
      )}
    </SearchBar>
  )
}

const mapDispatchToProps = {
  search: searchProjects,
  setFolderId,
}

export default connect(null, mapDispatchToProps)(ProjectSearchBar)
